<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs';


export default {
  extends: Pie,
  props: {
    legendPosition: {
      type: String,
      default: 'top',
    },
    labels: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: [
              '#7F77DD', // Lavender
              '#AFA9EC', // Periwinkle
              '#378ADD', // Ocean
              '#6FAED9', // Soft Sky
              '#9C8ADE', // Muted Violet
              '#CFA6B8', // Dusty Rose
              '#E6D8F2', // Soft Lilac
              '#EDC1CF', // Soft Blush
            ],

            borderColor: '#FFFFFF',
            borderWidth: 2,

            hoverBorderWidth: 3,
            hoverOffset: 6,

            data: this.data,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,

        legend: {
          position: this.legendPosition,

          labels: {
            generateLabels: (chart) => {
              const data = chart.data;
              const dataset = data.datasets[0];
              const total = dataset.data.reduce((a, b) => a + b, 0);

              return data.labels.map((label, i) => {
                const value = dataset.data[i];
                const percent = ((value / total) * 100).toFixed(1);

                return {
                  text: `${label} (${percent}%)`,
                  fillStyle: dataset.backgroundColor[i],
                  hidden: isNaN(value),
                  index: i,
                };
              });
            },
          },
        },
      },
    );
  },
};
</script>

<style scoped>
div {
  height: 100%;
}
</style>
